import APIController from '../core-api-controller';

export const fetchCurrentLabOrderApi = () => {
  const path = `${APIController.endpointApi}/client_user/lab_orders/current`;
  return APIController.getApiCallback(path);
};

export const fetchLabOrdersApi = ({ paramsStr = '', paramsObj = {} }) => {
  const path = `${APIController.endpointApi}/client_user/lab_orders${paramsStr ? paramsStr : ''}`;
  return APIController.getApiCallback(path, paramsObj);
};

export const fetchLabPanelApi = () => {
  const path = `${APIController.endpointApi}/client_user/users/fetch_lab_panel`;
  return APIController.getApiCallback(path);
};

export const fetchLabOrderPatientApi = () => {
  const path = `${APIController.endpointApi}/client_user/lab_orders/new`;
  return APIController.getApiCallback(path);
};

export const createLabOrderPatientApi = (payload = {}) => {
  const path = `${APIController.endpointApi}/client_user/lab_orders`;
  return APIController.postCallback(path, payload);
};

export const fetchLabAppointmentSlotsApi = ({ labId = '', queryStr = '' }) => {
  const path = `${APIController.endpointApi}/client_user/lab_orders/${labId}/fetch_appointment_availability${queryStr ? queryStr : ''}`;
  return APIController.getApiCallback(path);
};

export const bookLabAppointmentApi = (data = {}, labOrderId = '') => {
  const path = `${APIController.endpointApi}/client_user/lab_orders/${labOrderId}/book_appointment`;
  return APIController.postCallback(path, data);
};

export const rescheduleLabAppointmentApi = (data = {}, labOrderId = '') => {
  const path = `${APIController.endpointApi}/client_user/lab_orders/${labOrderId}/reschedule_appointment`;
  return APIController.postCallback(path, data);
};

export const fetchLabOrderPdfApi = ({ id, paramsStr = '', paramsObj = {}, responseType }) => {
  const path = `${APIController.endpointApi}/client_user/lab_orders/${id}/order_pdf${paramsStr ? paramsStr : ''}`;
  return APIController.getApiCallback(path, paramsObj, null, responseType);
};
